import * as yup from 'yup'

export const loginSchema = yup.object({
	email: yup
		.string()
		.email('Correo inválido')
		.min(5, 'Mínimo 5 caracteres')
		.max(50, 'Máximo 50 caracteres')
		.required('El correo es obligatorio'),
	password: yup
		.string()
		.min(6, 'Mínimo 6 caracteres')
		.max(30, 'Máximo 30 caracteres')
		.required('La contraseña es obligatoria'),
})

export const loginCodeSchema = yup.object({
	code: yup
		.number()
		.min(6, 'Minimo 6 caracteres')
		.required('El codigo es obligatorio'),
})
